export default __webpack_public_path__ + "static/media/psycho_three.78868c86.png";